import "apps/pathways/styles/components/pathway-stats.scss";
import React from 'react';
import Tooltip from 'library/components/tooltip';
import { Link } from 'library/util/core-router';
import { CompletedData } from 'apps/pathways/services/pathway';
import LockedSvg from 'library/icons/lock.svg';

const VeryDifficult = () => (
    <svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g strokeWidth="1" fill="none" fillRule="evenodd" fill="#000000" transform="translate(9,19)">
            <polygon points="63 0 91 56 63 112 35 56"></polygon>
            <polygon points="119 0 147 56 119 112 91 56"></polygon>
            <text id="VERY-DIFFICULT" fontFamily="Lato-Medium, Lato" fontSize="24" fontWeight="400">
                <tspan x="0.028" y="155">VERY DIFFICULT</tspan>
            </text>
        </g>
    </svg>
)

const Difficult = () => (
    <svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g strokeWidth="1" fill="none" fillRule="evenodd" fill="#000000">
            <polygon id="Triangle" points="100 20 128 76 100 132 72 76"></polygon>
            <text id="DIFFICULT" fontFamily="Lato-Medium, Lato" fontSize="24" fontWeight="400">
                <tspan x="41.458" y="175">DIFFICULT</tspan>
            </text>
        </g>
    </svg>
)

const Moderate = () => (
    <svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fill="#3595B7">
            <text id="MODERATE" fontFamily="Lato-Medium, Lato" fontSize="24" fontWeight="400">
                <tspan x="34.192" y="175">MODERATE</tspan>
            </text>
            <rect x="38" y="15" width="123" height="123"></rect>
        </g>
    </svg>
)

const Easy = () => (
    <svg width="200px" height="200px" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fill="#66CC66">
            <text id="EASY" fontFamily="Lato-Medium, Lato" fontSize="24" fontWeight="400">
                <tspan x="71.49" y="175">EASY</tspan>
            </text>
            <circle cx="100.5" cy="76.5" r="61.5"></circle>
        </g>
    </svg>
)

const DifficultyIcon = ({ difficulty }) => {
    difficulty = parseInt(difficulty);

    if (difficulty > 8) {
        return <VeryDifficult />
    } else if (difficulty > 6) {
        return <Difficult />
    } else if (difficulty > 4) {
        return <Moderate />
    }
    return <Easy />
}

const TooltipModal = ({ children }) => (
  <div dangerouslySetInnerHTML={{__html: children}} />
)

const PathwayStat = ({ children, label, tooltip }) => (
    <div className="pathway-stat">
        <div className="pathway-stat-value">{ children }</div>
        <div className="pathway-stat-label">
            { label }
        </div>
        <div className="pathway-stat-info">
            <Tooltip modalClassName="pathway-stat-info-tooltip tooltip" element="span" modal={<TooltipModal>{tooltip}</TooltipModal>}>?</Tooltip>
        </div>
    </div>
)


class OverallReadiness extends React.Component {
  state = {
    loading: false,
    locked: false
  }

  componentWillMount() {
    this.load();
  }

  load = async () => {
    this.setState({
      loading: true
    });
    const completed_data = await CompletedData();

    this.setState({
      loading: false,
      locked: !completed_data.survey
    });
  }

  render() {
    const {
      loading,
      locked
    } = this.state;
    const {
      readiness
    } = this.props;

    if (loading) {
      return (
        <span className={'pathway-readiness locked'}>
          <svg viewBox="0 0 200 200">
            <text fill="currentColor" alignmentBaseline="middle" textAnchor="middle" fontSize="32" x="100" y="100">loading</text>
          </svg>
          <span className="pathway-readiness-number">
            99
          </span>
        </span>
      );
    }

    return (
      <span title={locked?'Complete your profile to unlock readiness':null} className={['pathway-readiness', locked ? 'locked' : null].filter(c=>c).join(' ')}>
        {
          locked
            ? <LockedSvg className="icon" />
            : null
        }
        <span className="pathway-readiness-number">
          { locked ? 99 : readiness }
        </span>
      </span>
    );
  }
}

const PathwayStats = ({ stats }) => (
  <div className="pathway-stats">
    <PathwayStat
      tooltip="<strong>How difficult will it be to land your target job?</strong><br /> <em>This value can range from Easy to Very Difficult and it factors in the timeline to a career and available jobs.</em>"
      label="difficulty"
    >
      <DifficultyIcon difficulty={stats.difficulty || ''} />
    </PathwayStat>
    <PathwayStat
      tooltip="<strong>How ready are you for the job right now?</strong><br /> <em>Your readiness score looks at your hard skills, soft skills, and education data and compares it to that of your target job so you can evaluate how ready you are.</em>"
      label="readiness"
    >
      <OverallReadiness readiness={stats.readiness||0} />
    </PathwayStat>
    <PathwayStat
      tooltip="<strong>How long will it take you to complete all the steps in your path?</strong><br /> <em>This year range takes into account education timeframes and time spent in intermediate jobs along the pathway.</em>"
      label="years"
    >
      { (stats.length || '').replace(/\s/g, '') }
    </PathwayStat>
  </div>
);

export default PathwayStats;
